import { Box } from '@mui/material';
import { CustomTable } from '../../common/CustomTable';

interface SmsAgent {
  agentId: number;
  agentName?: string;
  agent_name?: string;
  inboundMessages?: number;
  inbound?: number;
  outboundMessages?: number;
  outbound?: number;
  totalMessages?: number;
  total_messages?: number;
  count?: number;
  avgLength?: number;
  avg_length?: number;
}

interface SmsAgentsTabProps {
  agents: SmsAgent[];
  comparison?: SmsAgent[];
  formatWithComparison: (value: string | number, prevValue?: string | number) => React.ReactNode;
  findAgentComparison: <T extends { agentId: number }>(agentId: number, comparisonAgents?: T[]) => T | undefined;
}

export const SmsAgentsTab = ({
  agents,
  comparison,
  formatWithComparison,
  findAgentComparison,
}: SmsAgentsTabProps) => {
  return (
    <Box sx={{ mt: 2 }}>
      <CustomTable
        title='Messages by Agent'
        columns={[
          { key: 'agentName', label: 'Agent' },
          { key: 'inbound', label: 'Inbound' },
          { key: 'outbound', label: 'Outbound' },
          { key: 'total', label: 'Total' },
          { key: 'avgLength', label: 'Avg Length' },
        ]}
        rows={agents.map((a) => {
          const inbound = a.inboundMessages || a.inbound || 0;
          const outbound = a.outboundMessages || a.outbound || 0;
          const total = a.totalMessages || a.total_messages || a.count || 0;
          const avgLength = a.avgLength || a.avg_length || 0;

          const prevData = findAgentComparison(a.agentId, comparison);
          const prevInbound = prevData?.inboundMessages || prevData?.inbound || 0;
          const prevOutbound = prevData?.outboundMessages || prevData?.outbound || 0;
          const prevTotal = prevData?.totalMessages || prevData?.total_messages || prevData?.count || 0;
          const prevAvgLength = prevData?.avgLength || prevData?.avg_length || 0;

          return {
            agentName: a.agentName || a.agent_name || 'Unknown',
            inbound: formatWithComparison(inbound, prevInbound),
            outbound: formatWithComparison(outbound, prevOutbound),
            total: formatWithComparison(total, prevTotal),
            avgLength: formatWithComparison(avgLength, prevAvgLength),
          };
        })}
        defaultText='No agent data available'
        loading={false}
        exportable={true}
        exportFilename='sms-by-agent.csv'
      />
    </Box>
  );
};
